import { Storage } from '@frontend/web-storage';

export enum EStorageKey {
  TITLE = 'title',
  THEME = 'theme',
  TOKEN = 'token',
  USER_ID = 'user_id',
  BO_TOKEN = 'token',
  BO_LOGIN_STATUS = 'BO_LOGIN_STATUS',
  LANGUAGE = 'language',
  PASSWORD = 'password',
  INDICATORS = 'indicators',
  THEME_SCHEME = 'theme_scheme',
  BALANCE_OPTIONS = 'balance_options',
  SEARCH_HISTORY = 'search_history',
  META_TRADER_ID = 'meta_trader_id',
  META_TRADER_GROUP = 'meta_trader_group',
  BIOMETRICS_ENABLE = 'biometrics_enable',
  TRADE_SUBSCRIPTION = 'trade_subscription',
  MARKET_SUBSCRIPTION = 'market_subscription',
  LOGIN_AS = 'LOGIN_AS',
  ASK_PRICE_VISIBLE = 'ASK_PRICE_VISIBLE',
  REMEMBER_ME = 'REMEMBER_ME',
  ACCOUNT_SWITCHED = 'ACCOUNT_SWITCHED',
  VOLUME_MODE_PREFERENCE = 'VOLUME_MODE_PREFERENCE',
  FCM_TOPICS = 'FCM_TOPICS',
  SHOULD_SHOW_FEATURE_ANNOUNCEMENT_MODAL = 'SHOULD_SHOW_FEATURE_ANNOUNCEMENT_MODAL', // To show feature announcement modal once per login session , remove after showing
  TRADING_ACCOUNT_IDENTITY = 'TRADING_ACCOUNT_IDENTITY',
  INDICATOR_CUSTOM_COLORS = 'INDICATOR_CUSTOM_COLORS'
}

const CIPHER_TOKENS = {
  TOKEN: 'secretPassToken',
  NORMAL: 'secretPassNormal',
  USER_ID: 'secretPassUserId',
  PASSWORD: 'secretPassPassword'
};

const storage = new Storage({
  cipherTokens: CIPHER_TOKENS
});

export default storage;
